@for (toast of toasts$ | async; track toast) {
  <div class="toast" [ngClass]="toast.type">
    <span>{{ toast.message }}</span>
    <button (click)="dismiss(toast.id)">×</button>
  </div>
}
